import { render, staticRenderFns } from "./VesselsShow.vue?vue&type=template&id=2c9fe0d0&scoped=true&"
import script from "./VesselsShow.vue?vue&type=script&lang=js&"
export * from "./VesselsShow.vue?vue&type=script&lang=js&"
import style0 from "./VesselsShow.vue?vue&type=style&index=0&id=2c9fe0d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9fe0d0",
  null
  
)

export default component.exports